import React, { useState } from 'react'
import { gql, useQuery } from '@apollo/client'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import { isEmpty } from 'lodash'
import RouterLinkButton from 'components/router-link-button'
import EditAvailabilityDisplay, {
  EditAvailabilityDisplayLoading,
} from './edit-availability-display'

const GET_AVAILABILITY = gql`
  query CoachAvailability {
    coachAvailabilities {
      coachFacility {
        id
        name
      }
      startDate
      timeZone
      timeSlots {
        day
        startTime
        endTime
      }
    }
  }
`

const AvailabilityManagerWrapper = ({ children }) => (
  <>
    <Grid container item md={4} xs={12}>
      <Typography variant="h5">
        <Box fontWeight={500}>Availability</Box>
      </Typography>
    </Grid>
    <Grid container item md={7} xs={12}>
      <Box mb={4}>
        <Typography variant="body1" color="textSecondary">
          Determine when you will be available to coach your students during the
          week at each location.
        </Typography>
      </Box>
    </Grid>
    {children}
  </>
)

const AvailabilityManager = () => {
  const [selectedLocationId, setSelectedLocationId] = useState(null)
  const { data, loading, refetch } = useQuery(GET_AVAILABILITY)

  if (loading) {
    return (
      <AvailabilityManagerWrapper>
        <EditAvailabilityDisplayLoading />
      </AvailabilityManagerWrapper>
    )
  }

  if (isEmpty(data.coachAvailabilities)) {
    return (
      <AvailabilityManagerWrapper>
        <Typography variant="h6" color="textPrimary">
          You have not set up any facilities.
        </Typography>
        <Box mt={2}>
          <RouterLinkButton
            variant="contained"
            color="primary"
            to="/pga-coach/facilities/new"
          >
            Add Facility
          </RouterLinkButton>
        </Box>
      </AvailabilityManagerWrapper>
    )
  }

  const selectedAvailability = selectedLocationId
    ? data.coachAvailabilities.find(
      a => a.coachFacility.id === selectedLocationId,
    )
    : data.coachAvailabilities[0]

  return (
    <AvailabilityManagerWrapper>
      <Grid item lg={4} xs={12}>
        <Box mb={2}>
          {data.coachAvailabilities.length === 1 ? (
            <FormControl variant="outlined">
              <TextField
                disabled
                value={selectedAvailability.coachFacility.name}
                variant="outlined"
              ></TextField>
            </FormControl>
          ) : (
            <FormControl variant="outlined">
              <TextField
                select
                value={selectedAvailability.coachFacility.id}
                variant="outlined"
                label="Select Facility"
                onChange={e => setSelectedLocationId(e.target.value)}
              >
                {data.coachAvailabilities.map(a => (
                  <MenuItem key={a.coachFacility.id} value={a.coachFacility.id}>
                    {a.coachFacility.name}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          )}
          <RouterLinkButton
            color="primary"
            size="small"
            component="a"
            to="/pga-coach/facilities"
          >
            Manage Facilities
          </RouterLinkButton>
        </Box>
      </Grid>
      <EditAvailabilityDisplay
        availability={selectedAvailability}
        refetch={refetch}
      />
    </AvailabilityManagerWrapper>
  )
}

export default AvailabilityManager
